module.exports = __webpack_public_path__ + "static/media/Item_Weapon_MP5K_C.efe5991a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/item/Weapon/Main/Item_Weapon_MP5K_C.png
// module id = ./src/assets/item/Weapon/Main/Item_Weapon_MP5K_C.png
// module chunks = 0